import { render, staticRenderFns } from "./StatisticCardGenerator.vue?vue&type=template&id=06b1eed3&scoped=true&"
import script from "./StatisticCardGenerator.vue?vue&type=script&lang=js&"
export * from "./StatisticCardGenerator.vue?vue&type=script&lang=js&"
import style0 from "./StatisticCardGenerator.vue?vue&type=style&index=0&id=06b1eed3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06b1eed3",
  null
  
)

export default component.exports